/**
 * Lets any screen open the shell's lateral chat with context.
 *
 * The prototype does this with a global `window.openDirectChatWithPrompt`
 * that seeds a text prompt into the one lateral assistant. We keep the same
 * shape — one chat, opened from elsewhere — but pass the insight object
 * instead of a sentence, because `ChatAssistant` already knows how to build
 * its opening message from it (`initialContext`).
 *
 * This replaces the second `ChatAssistant` instance that `InsightsPanel`
 * used to mount inside an MUI `Drawer`: the app had two chats, the design
 * has one.
 */

let listener = null;

export const chatLauncher = {
  /** Registered by the floating ChatAssistant while it is mounted. */
  register(handler) {
    listener = handler;
    return () => {
      if (listener === handler) listener = null;
    };
  },

  /**
   * Opens the lateral chat for an insight. Returns false when no chat is
   * mounted, so the caller can tell the user instead of failing silently.
   */
  openWithInsight(insight) {
    if (!listener) return false;
    listener({ contextType: 'insight', context: insight });
    return true;
  },
};

export default chatLauncher;
